import Vue from "vue"
import Vuex from "vuex"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import axios from "axios"
import Toasted from "vue-toasted"
import VueSplide from "@splidejs/vue-splide"
import "tailwindcss/tailwind.css"
import "./styles/global.css"
import VueMasonry from "vue-masonry-css"
import VueQuillEditor from "vue-quill-editor"
import "quill/dist/quill.core.css"
import "quill/dist/quill.snow.css"
import "quill/dist/quill.bubble.css"

import $ from "jquery"
window.jQuery = window.$ = $
import "summernote/dist/summernote-lite.css"
import "summernote/dist/summernote-lite.js"

Vue.use(VueMasonry)
Vue.use(Vuex)
Vue.use(Toasted)
Vue.use(VueSplide)
Vue.use(VueQuillEditor)

axios.defaults.baseURL = process.env.VUE_APP_BASE_PATH
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount("#app")
